import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import MainPage from "./containers/MainPage/MainPage";
import Cloackroom from "./components/Cloackroom/Cloakroom";
import Architecture from "./components/Architecture/Architecture";
import "./App.css";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Switch>
          <Route path="/szatnia_samoobslugowa" component={Cloackroom} />
          <Route path="/architektura_i_budownictwo" component={Architecture} />
          <Route path="/" exact component={MainPage} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js